export const PONTOS_DOTZ_TRAVEL = {
  Header: 'TERMOS E CONDIÇÕES DA CAMPANHA DOTZ E HOTEIS',
  Body: [
    {
      Title: null,
      Paragraphs: [
        `Por meio desta oferta, divulgamos os Termos e Condições da campanha <strong>"Dotz e Hotéis"</strong>,
        por meio da qual os usuários cadastrados na Dotz que inserirem seu CPF na loja Dotz, e realizarem
        reservas nos <strong>Hotéis cadastrados</strong>, através do botão "<em>Travel</em>", disponível na
        plataforma Rappi, <strong>acumularão pontos Dotz</strong>, durante período específico.`,
        '"Usuário" para fins deste T&amp;C significa a pessoa humana inscrita na plataforma Rappi.',
      ]
    },
    {
      Title: 'REGRAS PRINCIPAIS DA PROMOÇÃO:',
      Paragraphs: [
        `<ul>
          <li>
              Esta campanha aplica-se somente aos usuários cadastrados na
              Dotz que realizarem seus pedidos no período de <strong>01 de julho de 2021 às 00:01 até 01 de agosto
              de 2021 às 23:59, ou até que a verba destinada à campanha seja esgotada.</strong>;
          </li>
        </ul>`,
        `<ul>
          <li>
              Campanha válida apenas para os usuários cadastrados na Dotz,
              que realizarem reservas nos <strong>Hotéis cadastrados</strong>, através do botão "<em>Travel</em>",
              mediante inserção do CPF na loja Dotz, na plataforma de intermediação do Rappi;
          </li>
        </ul>`,
        `<ul>
          <li>
              Esclarece-se que o acúmulo é de 6 (seis) Dotz a cada R$ 1,00
              gasto em Hotéis;
          </li>
        </ul>`,
        `<ul>
          <li>
              Os Dotz acumulados terão validade de 48 meses a partir da data
              de crédito na Dotz.
          </li>
        </ul>`,
        `<ul>
          <li>
              Os Dotz serão creditados em até 72 (setenta e duas) horas
              contados da finalização da compra do produto pelo cliente, desde que o número do CPF informado seja
              válido e previamente cadastrado na Dotz.
          </li>
        </ul>`,
        `<ul>
          <li>
              O Rappi e a Dotz não se responsabilizam pela informação
              incorreta, pelo consumidor, do número de CPF.
          </li>
        </ul>`,
        `<ul>
          <li>
              O crédito de Dotz será realizado no mesmo número CPF daquele
              realizador da compra (informado no cadastro do parceiro e/ou fluxo de compra), não sendo permitida a
              doação dos pontos a terceiros.
          </li>
        </ul>`,
        `<ul>
          <li>
              Esclarece-se que a quantidade de Pontos Dotz será calculada
              sobre o montante do valor dos produtos adquiridos no aplicativo Rappi.
          </li>
        </ul>`,
        `<ul>
          <li>
              Campanha válida exclusivamente para compras acima de R$ 3,00
              (três reais) por pedido realizado, mediante aplicativo Rappi;
          </li>
        </ul>`,
        `<ul>
          <li>
              Promoção válida nas áreas de cobertura do aplicativo em São
              Paulo, Belo Horizonte, Curitiba e no Rio de Janeiro, onde houverem lojas parceiras credenciadas e
              com estoque dos produtos;
          </li>
        </ul>`,
        `<ul>
          <li>
              Campanha válida somente para pedidos realizados e pagos
              através dos meios de pagamento: <em>Paypal, Cartão de crédito Visa, Cartão de crédito Mastercard,
              todos os cartões de créditos que o Rappi aceita;</em>
          </li>
        </ul>`,
        `<ul>
          <li>
              Esclarece-se que não há limite de pedidos por usuário
              durante esta Promoção.
          </li>
        </ul>`,
        `<ul>
          <li>
              É esclarecido que esta campanha não se aplica a pedidos
              parcialmente ou totalmente cancelados;
          </li>
        </ul>`,
        `<ul>
          <li>
              Promoção válida enquanto durarem os estoques;
          </li>
        </ul>`,
        `<ul>
          <li>
              Promoção não cumulativa;
          </li>
        </ul>`,
        `<ul>
          <li>
              Os cupons são únicos e individuais.
          </li>
        </ul>`,
      ]
    },
    {
      Title: 'CONDIÇÕES GERAIS DA PROMOÇÃO:',
      Paragraphs: [
        `Promoção válida até a data e hora estipuladas ou enquanto durarem os
        estoques. Reservamo-nos o direito de cancelar qualquer transação que, devido às suas características, viole
        as condições de elegibilidade a esta promoção.`,
        `Esta promoção é pessoal e intransferível, será aplicada apenas aos
        usuários que aplicarem a promoção.`,
        `A Rappi se reserva o direito de encerrar esta promoção a qualquer
        momento em caso de fraude ou desviação da doação para terceiros.`,
        `O usuário reconhece e aceita que o fornecedor direto dos produtos é o
        Parceiro Comercial (estabelecimento), uma vez que este é o único que exibe, oferece, promove e comercializa
        produtos para os usuários/consumidores através da Plataforma.`,
        `O Usuário reconhece e aceita que as informações fornecidas e
        registradas na plataforma virtual Rappi são verdadeiras e confiáveis, assumindo total responsabilidade por
        sua falsidade. As informações fornecidas terão o caráter de uma declaração juramentada, os Usuários têm
        total responsabilidade pela autenticidade e veracidade das mesmas, não sendo a Rappi responsável, caso o
        Usuário incorra na omissão e/ou erro no momento do carregamento do dados solicitados pelos Usuário para
        obter os benefícios da Promoção.`,
        `A Rappi se reserva o direito de cancelar a promoção, cancelar o código
        e bloqueando a conta do Usuário a qualquer momento, se for determinado que estão ocorrendo fraude ou ação
        ilícita para obtenção do benefício.`,
        `A Rappi se reserva o direito de modificar as condições ou cancelar
        esta promoção a qualquer momento e a seu critério livre.`,
        `O Rappi não permitirá que o Usuário acesse a promoção quando for
        verificado que as contas referidas são fictícias ou falsas. Usuários que realmente não constituem uma pessoa
        física identificável por meio de um documento de identidade emitido pela autoridade competente.`,
        `A RAPPI reserva-se o direito, a seu exclusivo critério, de modificar,
        alterar ou atualizar estes Termos e Condições a qualquer momento. As modificações serão comunicadas no
        aplicativo RAPPI e entrarão em vigor imediatamente a partir do momento de sua publicação.`,
        `O Rappi não comercializa produtos, pois é apenas uma plataforma
        tecnológica de intermediação entre terceiros que exibe serviços e produtos aos usuários/consumidores que os
        adquirem.`,
        'Promoção válida na área de cobertura do Rappi para usuários do Rappi no Brasil.',
        'Promoção não acumulável com outras promoções.',
        `Consulte nossos
            <a href="https://legal.rappi.com/brazil/termos-e-condicoes-de-uso-da-plataforma-rappi/">
                <span>
                    Termos de Uso e Condições da Plataforma Rappi
                </span>
            </a>
            e
            <a
            href="https://legal.rappi.com/brazil/aviso-de-privacidade-e-politicas-de-uso-das-informacao-utilizadas-pela-rappi/">
                <span>
                    Aviso de Privacidade de Dados
                </span>
            </a>`,
        'São Paulo/SP.',
      ]
    }
  ]
};
